<template>
    <el-dialog title="转库存" :visible.sync="dialogVisible" width="35%" append-to-body @close="close">
        <div class="body">
              <el-tabs v-model="returnInventoryType" @tab-click="Tab_Click">
             <el-tab-pane label="新建库存" name="0">   
                 <el-col :span="24">
                <el-upload
                    ref="upload"
                    :action="action"
                    list-type="picture-card"
                    :on-success="handleAvatarSuccess"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :headers="customHeaders"
                    multiple
                >
                    <i class="el-icon-plus" style="color: #0724ef;"></i>
                </el-upload>
                <el-divider></el-divider>
                <div class="form">
                    <el-form ref="form" label-width="100px" style="margin-top:10px;">
                        <el-form-item label="商品全称:">
                            <el-input style="width:200px;" placeholder="全称" v-model="productFullName"></el-input>
                        </el-form-item>
                        <el-form-item label="商品简称:">
                            <el-input style="width:200px;" placeholder="简称" v-model="productSimpleName"></el-input>
                        </el-form-item>
                           <el-form-item label="规格尺寸:">
                            <el-input style="width:200px;" placeholder="规格尺寸" v-model="inventorySku"></el-input>
                        </el-form-item>
                        <el-form-item label="商品描述:">
                            <el-input
                                style="width:500px;"
                                placeholder="规格型号说明"
                                v-model="productDescription"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="库存申请数量:">
                            <el-input-number
                                v-model="predictCount"
                                :min="1"
                                :max="1000"
                                label="数量"
                                size="mini"
                            ></el-input-number>
                        </el-form-item>
                    </el-form>
                </div>
                <el-dialog :visible.sync="ImageVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
                 </el-col>
            </el-tab-pane>
             <el-tab-pane label="匹配已有库存" name="1">
                <el-form ref="form" label-width="100px" style="margin-top:10px;">
                        <el-form-item label="库存编号:">
                            <el-input style="width:200px;" placeholder="库存编号" v-model="inventoryNumber"></el-input>
                        </el-form-item>
                            <el-form-item label="库存申请数量:">
                            <el-input-number
                                v-model="predictCount"
                                :min="1"
                                :max="1000"
                                label="数量"
                                size="mini"
                            ></el-input-number>
                        </el-form-item>
                    </el-form>
             </el-tab-pane>
             </el-tabs>
         
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary"  @click="Add"  :disabled="loadingStatua">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { Baseurl } from "@/api/api/api";
export default {
    name: "Addinventory",
    data() {
        return {
            dialogVisible: false,
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            ImageVisible: false,
            dialogImageUrl: "",
            loadingStatua: false,

            returnInventoryType:'0',
            inventoryNumber:"",
            productFullName: "",
            productSimpleName: "",
            inventorySku:"",
            productDescription: "",
            predictCount: "",
            imagesList: [],
        };
    },
    watch:{
        loadingStatua:function(loadingStatua){
                console.log(loadingStatua)
                this.loadingStatua = loadingStatua;
        }
    },
    methods: {
         Tab_Click(tab, event) {
              this.imagesList = [];
            this.productFullName = "";
            this.productSimpleName = "";
            this.inventorySku = "";
            this.productDescription = "";
            this.predictCount = "";
            this.inventoryNumber = "";
         },
        init() {
            this.dialogVisible = true;
        },
        handleRemove(file, fileList) {
            this.imagesList = fileList;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.ImageVisible = true;
        },
        //图片上传
        handleAvatarSuccess(response, file, fileList) {
            this.imagesList.push(response.data);
            // console.log(response, file, fileList);
        },
        Add() {
            if(Number(this.returnInventoryType) == 0){
                if (!this.imagesList.length) {
                    this.$message.warning('请先添加图片')
                    return
                }else if(this.productFullName == ""){
                this.$message.warning("商品全称不能为空！")
                return;
            }else if(this.productSimpleName == ""){
                this.$message.warning("商品简称不能为空！")
                return;
            }else if(this.inventorySku==""){
                this.$message.warning("规格尺寸不能为空！")
                return;
            }else if(this.productDescription == ""){
                this.$message.warning("商品描述不能为空！")
                return;
            }
            }else{
                if(this.inventoryNumber == ""){
                    this.$message.warning('请先输入库存编号')
                    return
                }
            }
           
            const data = {
                imagesList: this.imagesList,
                productFullName: this.productFullName,
                productSimpleName: this.productSimpleName,
                inventorySku:this.inventorySku,
                productDescription: this.productDescription,
                predictCount: this.predictCount,
                returnInventoryType:this.returnInventoryType,
                inventoryNumber:this.inventoryNumber
            };
                // console.log(JSON.parse(JSON.stringify(data.predictCount)));
          
        
            // return;
            this.$emit("confirm", data);
            this.dialogVisible = false;
            this.$refs.upload.clearFiles();
        },
        close() {
            this.dialogVisible = false;
            this.imagesList = [];
            this.productFullName = "";
            this.productSimpleName = "";
            this.inventorySku = "";
            this.productDescription = "";
            this.predictCount = "";
            this.loadingStatua = false;
            this.inventoryNumber = "";
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/ {
    .el-pagination {
        margin-right: 0px !important;
    }
    .form .el-form-item {
        margin-bottom: 5px;
    }
}
</style>

<style>
.body {
    width: 100%;
}
.link {
    display: inline-block;
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
}
.prduct_img {
    width: 300px;
    height: 300px;
}
.page {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
</style>
